import { FieldBase } from '@/components/form/fieldBase';
import ColorPicker from '@/domain/termine/components/ColorPicker/ColorPicker';
import { useCalendarContext } from '@/domain/termine/features/Calendar/shared/CalendarContext';
import { ColorPickerDrawer } from '@/domain/termine/features/UpdateTermin/Mobile/components/ColorPickerDrawer';
import { UpdateTermineFormProps } from '@/domain/termine/features/UpdateTermin/shared/types';
import { MarkierungType } from '@/domain/termine/shared/types/Markierung';
import { useTranslation } from 'react-i18next';

export function ColorPickerFormField({ form }: UpdateTermineFormProps) {
  const { t } = useTranslation();
  const { kalender } = useCalendarContext();

  return (
    <form.Subscribe selector={(state) => state.values.terminKalenderId}>
      <form.AppField
        name="markierung"
        validators={{
          onChangeListenTo: ['terminKalenderId'],
          onChange: ({ value, fieldApi }) => {
            const currentTerminKalender =
              form.getFieldValue('terminKalenderId');
            const changedTerminKalender = value !== currentTerminKalender;

            if (changedTerminKalender) {
              const kalenderId = kalender.filter(
                (item) => item.id === currentTerminKalender,
              );

              const markierung = kalenderId.flatMap((item) => item.markierung);
              console.log(value);
              if (value === 'LIGHTGRAY' && value !== markierung[0]) {
                fieldApi.setValue(markierung[0]);
              }
            }
          },
        }}>
        {(field) => {
          const handleChange = (value: MarkierungType) => {
            field.handleChange(value);
            field.handleBlur();
          };

          return (
            <FieldBase
              label={t('domain.termine.form.fields.farbe')}
              className="w-fit">
              <div className="block md:hidden">
                <ColorPickerDrawer
                  value={field.state.value}
                  onChange={handleChange}
                />
              </div>
              <div className="hidden md:block">
                <ColorPicker
                  value={field.state.value}
                  onChange={handleChange}
                />
              </div>
            </FieldBase>
          );
        }}
      </form.AppField>
    </form.Subscribe>
  );
}
